import { connect } from 'react-redux';
import ServerErrorPage from './ServerErrorPage';
import { setServerError } from '../../actions/App';

const mapStateToProps = ({ app }) => ({
  serverError: app.serverError,
});

export default connect(
  mapStateToProps,
  { setServerError },
)(ServerErrorPage);
